import CommonImg from "@/components/Common/Img";
import { cn } from "@/libs/utils";

interface CardProps {
  icon: string;
  title: string;
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
}

export default function Card({
  icon,
  title,
  children,
  className,
  containerClassName,
}: CardProps) {
  return (
    <div
      className={cn(
        "w-full bg-white rounded-xl border-[1px] border-gray-D",
        containerClassName
      )}
    >
      <div className="flex gap-2 items-center p-5">
        <CommonImg src={icon} alt={title} />
        <span className="text-sm text-gray-A font-semibold">{title}</span>
      </div>
      <div
        className={cn(
          "min-h-[280px] p-5 border-t-[1px] border-gray-D",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
